/* eslint-disable*/
import React from 'react';
import { IC } from './ebookShared';

function Ico({ d, size, cls }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size||16} height={size||16}
      viewBox="0 0 24 24" fill="none" stroke="currentColor"
      strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className={cls||''}>
      <path d={d} />
    </svg>
  );
}

function StatusDot({ status }) {
  if (status === 'completed') return <Ico d={IC.check} size={12} cls="text-emerald-600 flex-shrink-0" />;
  if (status === 'in_progress') return <span className="w-2 h-2 bg-indigo-500 rounded-full animate-pulse flex-shrink-0" />;
  return <span className="w-2 h-2 bg-slate-200 rounded-full flex-shrink-0" />;
}

export default function EbookTOC({ book, chapters, activeTopic, expandedChapters, setExpandedChapters, onSelectTopic, loading }) {
  const allTopics = chapters.flatMap((c) => c.topics);
  const completedCount = allTopics.filter((t) => t.status === 'completed').length;
  const pct = allTopics.length > 0 ? Math.round((completedCount / allTopics.length) * 100) : 0;

  return (
    <aside className="w-64 h-full flex-shrink-0 bg-white border-r border-slate-200 flex flex-col overflow-hidden">
      {/* Book info */}
      <div className="px-4 py-4 border-b border-slate-100 flex-shrink-0">
        <div className="flex items-center gap-3 mb-3">
          <div className="w-10 h-10 bg-gradient-to-br from-indigo-500 to-purple-600 rounded-xl flex items-center justify-center flex-shrink-0">
            <Ico d={IC.book} size={18} cls="text-white" />
          </div>
          <div className="min-w-0">
            <p className="text-xs font-black text-slate-800 truncate leading-tight">{book?.title || 'Loading…'}</p>
            {book?.author && <p className="text-xs text-slate-400 truncate">by {book.author}</p>}
          </div>
        </div>
        <div className="flex items-center justify-between mb-1">
          <p className="text-xs text-slate-400">Progress</p>
          <p className="text-xs font-bold text-indigo-600">{pct}%</p>
        </div>
        <div className="h-1.5 bg-slate-100 rounded-full overflow-hidden">
          <div className="h-full bg-indigo-500 rounded-full transition-all" style={{ width: `${pct}%` }} />
        </div>
        <p className="text-xs text-slate-400 mt-1">{completedCount} of {allTopics.length} topics</p>
      </div>

      {/* Chapter list */}
      <div className="flex-1 overflow-y-auto py-2">
        {loading ? (
          <div className="flex flex-col gap-2 px-4 py-3">
            {[1,2,3,4].map((i) => <div key={i} className="h-4 bg-slate-100 rounded animate-pulse" />)}
          </div>
        ) : chapters.length === 0 ? (
          <p className="text-xs text-slate-400 text-center py-8">No chapters available</p>
        ) : chapters.map((ch) => (
          <div key={ch.chapterId}>
            <button
              onClick={() => setExpandedChapters((p) => ({ ...p, [ch.chapterId]: !p[ch.chapterId] }))}
              className="w-full flex items-center gap-2 px-4 py-2.5 text-left hover:bg-slate-50 transition-colors group">
              <Ico d={expandedChapters[ch.chapterId] ? IC.chevD : IC.chevR} size={13} cls="text-slate-400 flex-shrink-0" />
              <span className="flex-1 text-xs font-bold text-slate-700 truncate group-hover:text-indigo-700">{ch.chapterTitle}</span>
              <span className="text-xs text-slate-300 flex-shrink-0">
                {ch.topics.filter((t) => t.status === 'completed').length}/{ch.topics.length}
              </span>
            </button>
            {expandedChapters[ch.chapterId] && (
              <div className="pl-6 pr-3 pb-1">
                {ch.topics.map((t) => (
                  <button key={t.topicId}
                    onClick={() => onSelectTopic(t)}
                    className={`w-full flex items-center gap-2 px-3 py-2 rounded-xl text-left mb-0.5 transition-colors group ${activeTopic?.topicId === t.topicId ? 'bg-indigo-50 border border-indigo-200' : 'hover:bg-slate-50'}`}>
                    <StatusDot status={t.status} />
                    <span className={`flex-1 text-xs truncate ${activeTopic?.topicId === t.topicId ? 'font-bold text-indigo-700' : 'text-slate-600 group-hover:text-slate-800'}`}>
                      {t.topicTitle}
                    </span>
                  </button>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </aside>
  );
}
